import { Stack, Typography } from "@mui/material"

export default function ValueLabel({ value, label, color}) {
    return (
        <Stack direction="row" sx={{justifyContent: 'space-between'}}>
            <Typography variant="subtitle2">{value}</Typography>
            <Typography sx={{ml:1}} variant="body2" color="text.secondary">{label}</Typography>
        </Stack>
    )
}